import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { TicketList } from '../../../pages/TicketList'

const ticketListSearchSchema = z.object({
  search: z.string().optional(),
  statuses: z.array(z.coerce.number()).optional().catch([]),
  priorities: z.array(z.coerce.number()).optional().catch([]),
  showOverdue: z.coerce.boolean().optional(),
  // "Following": tickets the signed-in user follows
  following: z.coerce.boolean().optional(),
  assignees: z.array(z.string()).optional().catch([]),
  categories: z.array(z.string()).optional().catch([]),
  customers: z.array(z.string()).optional().catch([]),
  organizationIds: z.array(z.string()).optional().catch([]),
  fromDate: z.string().optional(),
  toDate: z.string().optional(),
  sortBy: z.string().default('createdat'),
  sortDescending: z.coerce.boolean().default(true),
  page: z.coerce.number().default(1),
  pageSize: z.coerce.number().default(20),
})

export const Route = createFileRoute('/helpdesk/tickets/')({
  component: TicketList,
  validateSearch: ticketListSearchSchema,
})